import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { StyleSettings } from "../../../../../styles/StyleSettings";

interface popupProps {
  fg_script: string;
}

/* DB SCRIPT의 HELP 팝업 */
const SN_SFA_ISSUE_REG_005_POP_004 = forwardRef(
  ({ fg_script }: popupProps, ref: React.Ref<any>) => {
    const [helperText, setHelperText] = useState("");

    useEffect(() => {
      const txt = getHelperText(fg_script);
      setHelperText(txt);
    }, []);

    useImperativeHandle(ref, () => ({
      onSave,
    }));

    const getHelperText = (fg_script: string) => {
      let returnStr = "";
      switch (fg_script) {
        case "B":
          returnStr = `
/* COLUMN ADD */
DO $$
BEGIN
IF EXISTS (
  SELECT 1 
  FROM information_schema.tables 
  WHERE table_schema = 'snotes' 
  AND table_name = 'sys_mmenu'
) THEN
  IF NOT EXISTS (
    SELECT 1 
    FROM information_schema.columns 
    WHERE table_schema = 'snotes' 
    AND table_name = 'sys_mmenu' 
    AND column_name = 'tm_amd'
  ) THEN
    ALTER TABLE sys_mmenu ADD COLUMN tm_amd TIMESTAMP;
  END IF;
END IF;
END;
$$ LANGUAGE plpgsql;

DO $$
BEGIN
IF EXISTS (
  SELECT 1 
  FROM information_schema.tables 
  WHERE table_schema = 'snotes' 
  AND table_name = 'sys_mmenu_history'
) THEN
  IF NOT EXISTS (
    SELECT 1 
    FROM information_schema.columns 
    WHERE table_schema = 'snotes' 
    AND table_name = 'sys_mmenu_history' 
    AND column_name = 'tm_amd'
  ) THEN
    ALTER TABLE sys_mmenu_history ADD COLUMN tm_amd TIMESTAMP;
  END IF;
END IF;
END;
$$ LANGUAGE plpgsql;

/* TABLE CREATE */
DO $$
BEGIN
IF NOT EXISTS (
  SELECT 1
  FROM information_schema.tables
  WHERE table_schema = 'snotes'
  AND table_name = 'sfa_issue_script'
) THEN 
  CREATE TABLE sfa_issue_script(
    cd_firm varchar(10) NOT NULL,
    no_issue varchar(20) NOT NULL,
    fg_script varchar(6) NOT NULL, /* P(SP, FUNCTION) R (TRIGGER) B TABLE COLUMN */
    txt_script text NOT NULL,
    tm_reg TIMESTAMP NULL,
    cd_user_reg varchar(20) NULL,
    tm_amd TIMESTAMP NULL,
    cd_user_amd varchar(20) NULL,
    yn_apply varchar(1) NOT NULL DEFAULT('N'),
    tm_apply TIMESTAMP NULL,
    tm_assign TIMESTAMP NULL,
    CONSTRAINT pk_sfa_issue_script PRIMARY KEY (
      cd_firm,
      no_issue,
      fg_script
    )
  );
END IF;
END;
$$ LANGUAGE plpgsql;
      `.trim();
          break;
        case "P":
          returnStr = `
/* PROCEDURE CREATE OR MODIFY */
DROP PROCEDURE IF EXISTS snotes.sp_test(varchar, varchar) RESTRICT;

CREATE OR REPLACE PROCEDURE snotes.sp_test (
  IN p_cd_firm varchar,
  IN p_no_docu varchar
)
  LANGUAGE plpgsql
  AS $procedure$
  BEGIN
  INSERT INTO sfa_issue_script ( 
    cd_firm, no_docu
  )
  VALUES(
    p_cd_firm, no_docu
  );
END;
$procedure$;


/* FUNCTION CREATE OR MODIFY */
DROP FUNCTION IF EXISTS snotes.fn_test (text) RESTRICT;

CREATE OR REPLACE FUNCTION fn_test (_dc text)
  RETURNS TABLE(dc text) 
  LANGUAGE plpgsql 
  AS $function$ 
DECLARE 
  _from int := 0; 
  _to int; 
  _len int := length(coalesce(_dc, '')); 
  _input text := coalesce(_dc, ''); 
BEGIN 
  LOOP 
    _to := position('|' in substr(_input, _from + 1)); 
    EXIT WHEN _to = 0; 
    dc := substr(_input, _from + 1, _to - 1); 
    RETURN NEXT; 
    _from := _from + _to; 
  END LOOP; 
  IF RIGHT(_input, 1) <> '|' THEN 
    dc := substr(_input, _from + 1); 
    RETURN NEXT; 
  END IF; 
END; 
$function$;


/* VIEW CREATE OR MODIFY */
DROP VIEW IF EXISTS v_mtl_clsisurcp;

CREATE VIEW v_mtl_clsisurcp
AS

/*생산,외주,이동,대체,기타*/ 
SELECT 
  l.cd_firm, l.no_io, l.no_line, l.tp_slip, l.fg_slip, l.dt_io, l.cd_biz, l.cd_item, 
  l.fg_io, l.qt, l.am, l.am_k, l.no_order, l.no_line_order, l.qt_cls, h.tp_trans
FROM mtl_qtio l
JOIN mtl_qtioh h ON h.cd_firm = l.cd_firm AND h.no_io = l.no_io 

UNION ALL

/* 구매 */ 
SELECT 
  l.cd_firm, l.no_pur, l.no_line, '1' AS tp_slip, '1' AS fg_slip, h.dt_pur, h.cd_biz, 
  l.cd_item, l.fg_io, l.qt, l.am, l.am_k, l.no_po, l.no_line_po, l.qt, '' AS tp_trans
FROM pur_purchasel l
JOIN pur_purchaseh h ON h.cd_firm = l.cd_firm AND h.no_pur = l.no_pur 

UNION ALL

/* 판매 */ 
SELECT 
  l.cd_firm, l.no_sales, l.no_line, '2' AS tp_slip, '2' AS fg_slip, h.dt_sales, h.cd_biz, 
  l.cd_item, l.fg_io, l.qt, l.am, l.am_k, l.no_so, l.no_line_so, l.qt, '' AS tp_trans
FROM sal_salesl l
JOIN sal_salesh h ON h.cd_firm = l.cd_firm AND h.no_sales = l.no_sales 

UNION ALL

 /*외주*/ 
SELECT 
  l.cd_firm, l.no_cls, l.no_line, '8' AS tp_slip, '1' AS fg_slip, h.dt_cls, h.cd_biz, 
  l.cd_item, '1' AS fg_io, l.qt, l.am, l.am_k, l.no_po, l.no_line_pol, l.qt, '' AS tp_trans
FROM sct_taxl l
JOIN sct_taxh h ON h.cd_firm = l.cd_firm AND h.no_cls = l.no_cls 
;`.trim();
          break;
        case "R":
          returnStr = `
/* TRIGGER CREATE OR MODIFY */
-- 작성 순서 : 트리거 삭제 → 트리거에서 사용된 함수 삭제 → 트리거에서 사용될 함수 생성 → 트리거 생성
DROP TRIGGER IF EXISTS ti_mas_table ON snotes.mas_table;

DROP FUNCTION IF EXISTS snotes.tr_ti_mas_table() RESTRICT;

CREATE OR REPLACE FUNCTION snotes.tr_ti_mas_table()
  RETURNS trigger
  LANGUAGE plpgsql
AS $function$
DECLARE
  _numrows int := 1;
BEGIN
  RETURN new;

EXCEPTION WHEN OTHERS THEN
    RAISE EXCEPTION USING ERRCODE = 'ET001', MESSAGE  = sqlerrm;
END;
$function$;

CREATE TRIGGER ti_mas_table 
AFTER INSERT ON snotes.mas_table 
FOR EACH ROW 
EXECUTE FUNCTION tr_ti_mas_table();
  `.trim();
          break;
      }
      return returnStr;
    };

    const onSave = () => {
      return true;
    };

    return (
      <div
        style={{
          border: "1px solid rgb(186,191,199)",
          overflow: "auto",
          fontSize: StyleSettings.font,
          borderRadius: "4px",
          padding: "8px",
          whiteSpace: "pre-wrap",
          height: "100%",
        }}
      >
        {helperText.split("\n").map((line, index) => (
          <React.Fragment key={index}>
            {line}
            <br />
          </React.Fragment>
        ))}
      </div>
    );
  }
);

export default SN_SFA_ISSUE_REG_005_POP_004;
